module.exports = __webpack_public_path__ + "static/media/fill.c9833c4a.svg";